import React from 'react';
import { Paper, TextField, MenuItem, Dialog, Fab, Typography } from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { setRejectSignatureRequestDialog, setSnackbar } from '../../redux';

export default () => {
  const rejectSignatureRequestDialog = useSelector(
    state => state.tasks.rejectSignatureRequestDialog
  );
  const dispatch = useDispatch();

  const handleReasonChange = event => {
    const updatedRejectSignatureRequestDialog = { ...rejectSignatureRequestDialog };
    updatedRejectSignatureRequestDialog.rejectSignatureRequestReasonId = event.target.value;
    dispatch(setRejectSignatureRequestDialog(updatedRejectSignatureRequestDialog));
  };

  const handleNoteChange = event => {
    const updatedRejectSignatureRequestDialog = { ...rejectSignatureRequestDialog };
    updatedRejectSignatureRequestDialog.rejectSignatureRequestNote = event.target.value;
    dispatch(setRejectSignatureRequestDialog(updatedRejectSignatureRequestDialog));
  };

  return (
    <Dialog open={rejectSignatureRequestDialog.open}>
      <div
        className="ConfirmationDialog"
        style={{
          position: 'fixed',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
        }}
      >
        {rejectSignatureRequestDialog.title.map(x => (
          <Typography
            gutterBottom
            component="p"
            variant="h5"
            align="center"
            style={{
              color: x.color || 'white',
              backgroundColor: x.backgroundColor || 'none',
              borderRadius: x.borderRadius || '0%',
              fontSize: x.fontSize || '',
            }}
          >
            {x.text}
          </Typography>
        ))}
        <Paper style={{ padding: '4px' }}>
          <TextField
            label="Причина за отказ"
            style={{ margin: '4px' }}
            select
            onChange={x => handleReasonChange(x)}
            fullWidth
            value={rejectSignatureRequestDialog.rejectSignatureRequestReasonId}
          >
            <MenuItem value={1}>Работа по мрежата, извън клиентското домакинство</MenuItem>
            <MenuItem value={2}>
              Клиентът отказва да разпише дигитално - предоставена хартиена бланка
            </MenuItem>
            <MenuItem value={3}>Системно затруднение с приложението</MenuItem>
            <MenuItem value={4}>Друго</MenuItem>
          </TextField>
        </Paper>
        <Paper style={{ padding: '4px' }}>
          <TextField
            label="Забележка"
            style={{ margin: '4px', marginBottom: '10px' }}
            value={rejectSignatureRequestDialog.rejectSignatureRequestNote}
            multiline
            fullWidth
            onChange={x => {
              handleNoteChange(x);
            }}
          />
        </Paper>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Fab
            id="ConfirmButton"
            style={{ marginTop: '25px', marginLeft: '25px', backgroundColor: '#5ab85a' }}
            onClick={() => {
              if (rejectSignatureRequestDialog.onConfirm) {
                const rejectReasonNote = rejectSignatureRequestDialog.rejectSignatureRequestNote;

                if (
                  rejectSignatureRequestDialog.rejectSignatureRequestReasonId === undefined ||
                  rejectSignatureRequestDialog.rejectSignatureRequestReasonId === null
                ) {
                  dispatch(
                    setSnackbar({ open: true, message: 'Поле "Причина за отказ" е задължително' })
                  );
                  return;
                }

                if (
                  rejectSignatureRequestDialog.rejectSignatureRequestReasonId === 4 &&
                  (rejectReasonNote === undefined ||
                    rejectReasonNote === null ||
                    rejectReasonNote === '' ||
                    rejectReasonNote === ' ' ||
                    rejectReasonNote === '.')
                ) {
                  dispatch(setSnackbar({ open: true, message: 'Поле "Забележка" е задължително' }));
                  return;
                }

                rejectSignatureRequestDialog.onConfirm(true, rejectSignatureRequestDialog);
                rejectSignatureRequestDialog.onCancel();

                dispatch(
                  setRejectSignatureRequestDialog({
                    open: false,
                    title: [],
                    onConfirm: null,
                    onCancel: null,
                  })
                );
              } else {
                dispatch(
                  setRejectSignatureRequestDialog({
                    open: false,
                    title: [],
                    onConfirm: null,
                    onCancel: null,
                  })
                );
              }
            }}
          >
            <Check style={{ color: 'white' }} />
          </Fab>
          <Fab
            style={{ marginTop: '25px', marginRight: '25px', backgroundColor: '#da291c' }}
            onClick={() =>
              setRejectSignatureRequestDialog.onCancel
                ? setRejectSignatureRequestDialog.onCancel()
                : dispatch(
                    setRejectSignatureRequestDialog({
                      open: false,
                      title: [],
                      onConfirm: null,
                      onCancel: null,
                    })
                  )
            }
          >
            <Close style={{ color: 'white' }} />
          </Fab>
        </div>
      </div>
    </Dialog>
  );
};
